<template>
  <div
    class="drop-down"
    @mouseenter="handleMouseOver"
    @mouseleave="handleMouseOut"
    @click="handleMyClick"
  >
    <div class="drop-down-title">
      <slot name="head">
        <span class="drop-down-userIcon" :class="{ unread: hasUnresdMsg }" v-if="showHeadIcon">
          <!--      新需求不再支持上传用户头像-->
          <!--          <img v-if="userIcon" :src="userIcon" alt="user logo">-->
          <img src="~img/profileicon.svg" alt="user logo" />
        </span>
        <button class="drop-button" :style="fontStyle" role="button">
          {{ title }}
        </button>
        <span :class="['drop-down-icon', iconImg === 'down' ? 'down' : 'up']"></span>
      </slot>
    </div>
    <transition name="fade">
      <ul class="drop-down-list" v-show="showList">
        <li
          v-for="(item, index) in list"
          :key="index"
          class="drop-down-li"
          :class="{ unread: item.key === 'notify' && hasUnresdMsg }"
          @click="handleClick(item)"
        >
          {{ item.label.includes('head-user-') ? $t(item.label) : item.label }}
          <img v-if="item.select" src="~img/icon-check.png" alt="icon check" />
        </li>
      </ul>
    </transition>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    name: 'DropDown',
    props: {
      title: {
        type: String,
        default: 'Eng',
      },
      list: {
        type: Array,
        default: () => [],
      },
      fontStyle: {
        type: Object,
        default: () => {},
      },
      userIcon: {
        type: String,
        default: '',
      },
      showHeadIcon: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        showList: false,
        iconImg: 'down',
      };
    },

    computed: {
      ...mapState(['hasUnresdMsg']),
    },

    methods: {
      handleMouseOver() {
        this.iconImg = 'up';
        this.showList = true;
      },

      handleMouseOut() {
        this.iconImg = 'down';
        this.showList = false;
      },
      handleMyClick() {
        this.isClick = !this.isClick;
        if (this.isClick) {
          this.iconImg = 'up';
          this.showList = true;
        } else {
          this.iconImg = 'down';
          this.showList = false;
        }
      },
      handleClick(item) {
        this.$emit('drowDownClick', item);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index.scss';
</style>
